import { render, staticRenderFns } from "./VideoControls.vue?vue&type=template&id=0e8332bd&scoped=true&"
import script from "./VideoControls.vue?vue&type=script&lang=js&"
export * from "./VideoControls.vue?vue&type=script&lang=js&"
import style0 from "./VideoControls.vue?vue&type=style&index=0&id=0e8332bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8332bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VIcon,VList,VListItem,VMenu,VSlider})
